export default __webpack_public_path__ + "static/media/exterior9.5ed29d4a.webp";